import { ReactElement } from 'react'

import isEmpty from 'lodash/isEmpty'

import { UNDEFINED_VALUE } from 'const/formatting'
import { formatAdAccountName } from 'helpers/formatting'
import { adAccountUrl } from 'routing/urls'
import { Brand } from 'types'

import { ResourceLink } from './ResourceLink'

interface AdAccountLinkProps {
    adAccount: Brand | null
    appendCountry?: boolean
}

function AdAccountLink({
    adAccount = null,
    appendCountry = true,
}: AdAccountLinkProps): ReactElement {
    if (!adAccount || isEmpty(adAccount)) {
        return <span>{UNDEFINED_VALUE}</span>
    }
    return (
        <ResourceLink to={adAccountUrl(adAccount.id)}>
            {formatAdAccountName(adAccount, { appendCountry })}
        </ResourceLink>
    )
}
export default AdAccountLink
